import { render, staticRenderFns } from "./ServiceResource.vue?vue&type=template&id=497e7832&"
import script from "./ServiceResource.vue?vue&type=script&lang=js&"
export * from "./ServiceResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports